/* Ruma — Regalo automático W&N: agrega/quita la postal según el subtotal de acuarelas W&N.
   El descuento nativo "Buy X Get Y" es quien la deja en $0; esto solo la mete al carrito. */
(function () {
  var CFG = window.RUMA_PROMO_REGALO;
  if (!CFG || !CFG.giftVariantId || !CFG.productIds || !CFG.productIds.length) return;

  var busy = false;
  var lastState = null;

  function refreshUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    if (/^\/cart/.test(window.location.pathname)) window.location.reload();
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function sync() {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subtotal = 0;
        var giftLine = null;
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) === String(CFG.giftVariantId)) { giftLine = item; return; }
          if (CFG.productIds.indexOf(String(item.product_id)) !== -1) {
            subtotal += (item.final_line_price != null ? item.final_line_price : item.line_price);
          }
        });
        var qualifies = subtotal >= CFG.threshold;
        var state = qualifies + '|' + (giftLine ? '1' : '0');
        if (state === lastState) return;
        lastState = state;

        if (qualifies && !giftLine) {
          return post('/cart/add.js', { items: [{ id: CFG.giftVariantId, quantity: 1 }] })
            .then(function (res) { if (res.ok) refreshUI(); });
        }
        if (!qualifies && giftLine) {
          return post('/cart/change.js', { id: giftLine.key, quantity: 0 })
            .then(function (res) { if (res.ok) refreshUI(); });
        }
      })
      .catch(function () { /* nunca romper el carrito por esta promo */ })
      .finally(function () { busy = false; });
  }

  // Reaccionar a cualquier cambio del carrito hecho por el tema
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(href) && !busy;
    return nativeFetch.apply(this, arguments).then(function (res) {
      if (isCartMutation) setTimeout(sync, 250);
      return res;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
